<rma-navigation-header redirectUrl="/manage-account/billing" />

<ng-container *transloco="let t; prefix: 'subscriptions.billing.call-unsubscribe'">
  <mat-card class="request-cancellation-container mx-4 mt-6 sm:!p-10 md:mx-auto">
    @if (!formSubmitted) {
      <form *rmaLet="isAgency$ as isAgency" class="no-default-styles text-center" [formGroup]="contactForm">
        <header>
          <h3 class="mb-3 text-heading-2">{{ t('title') }}</h3>
          <p class="call-text" [innerHTML]="isAgency ? t('agency-call-text') : t('call-text')"></p>
        </header>
        @if (isAgency) {
          <div class="contact-details">
            <h3 class="pb-3 text-heading-4">{{ t('contact-details.title') }}</h3>
            <mat-form-field appearance="outline">
              <mat-label>{{ t('contact-details.directors-name') }}</mat-label>
              <input type="text" [placeholder]="t('contact-details.directors-name')" matInput formControlName="contactName" required />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>{{ t('contact-details.phone-number') }}</mat-label>
              <input type="text" [placeholder]="'phoneNumber.placeholder' | transloco" matInput formControlName="phoneNo" required />
            </mat-form-field>
          </div>
        }
        <div class="flex justify-between">
          <a [routerLink]="'/manage-account/billing'" mat-button color="primary">{{ t('cancel') }}</a>
          <a [disabled]="submitting" (click)="onRequestCancellation()" mat-flat-button color="primary">{{ t('confirm-unsubscribe') }}</a>
        </div>
      </form>
    }

    @if (formSubmitted) {
      <header class="text-center">
        <rma-icon [rounded]="true" glyph="check" theme="primary" size="large" />
        <h3 class="mb-6 mt-3 text-center text-heading-2">{{ t('form-submitted.success.title') }}</h3>
      </header>
      <ul>
        <li class="flex items-center gap-4 pb-6">
          <rma-icon [rounded]="true" glyph="check" theme="primary" size="small" />
          <span [innerHTML]="t('form-submitted.success.desc.notification')"></span>
        </li>
        <li class="flex items-center gap-4 pb-6">
          <rma-icon [rounded]="true" glyph="phone" theme="primary" size="small" />
          <span [innerHTML]="t('form-submitted.success.desc.contact')"></span>
        </li>
        <li class="flex items-center gap-4 pb-6">
          <rma-icon [rounded]="true" glyph="thumb_up" theme="primary" size="small" />
          <span [innerHTML]="t('form-submitted.success.desc.access')"></span>
        </li>
      </ul>
      <div class="text-center">
        <a [routerLink]="'/manage-account/billing'" mat-flat-button color="primary">{{ t('back-to-billing') }}</a>
      </div>
    }
  </mat-card>
  @if (!formSubmitted) {
    <div class="mx-4 mt-6 text-center" [innerHTML]="t('footer-text')"></div>
  }
</ng-container>
